{
  "upload": {
    "absent": {
      "text": "No tiene ninguna licencia activa."
    },
    "text": "Deposite su archivo de licencia",
    "title": "Haga clic aquí para seleccionar y depositar un archivo de licencia",
    "dropInformation": "Deposite la licencia aquí o haga clic aquí para seleccionarla",
    "validation": {
      "fileMandatory": "El archivo debe ser un .JWT o un .OPL",
      "fileEmpty": "El archivo no debe estar vacío",
      "fileSize": "El tamaño del archivo debe ser inferior a 750 MB"
    },
    "new": {
      "text": "Depositar un nuevo archivo de licencia",
      "title": "Haga clic aquí para seleccionar y depositar un nuevo archivo de licencia"
    },
    "loading": "Cargando...",
    "success": "Licencia válida",
    "errors": {
      "signature_invalid": "Se ha detectado un error de firma con el archivo de licencia.",
      "license_id_already_exists": "El identificador de licencia es el mismo que el de la licencia actual.",
      "platform_id_not_match": "El identificador de la plataforma no coincide.",
      "organization_id_not_match": "El identificador de la organización no coincide.",
      "expires_contracted_invalid": "La fecha de caducidad es anterior a la fecha actual.",
      "expires_tolerate_invalid": "La fecha de caducidad no coincide con el valor esperado.",
      "max_devices_total_value_invalid": "El número total de equipos no coincide con el valor esperado.",
      "max_devices_total_contracted_expires_invalid": "El número de equipos es inferior al valor actual de la organización.",
      "max_devices_total_tolerated_expires_invalid": "El número total de equipos no coincide con el valor esperado.",
      "max_devices_by_type_value_invalid": "El número total de equipos no coincide con el valor esperado.",
      "max_devices_by_type_contracted_expires_invalid": "El número de equipos es inferior al valor actual de la organización.",
      "max_devices_by_type_tolerated_expires_invalid": "El número total de equipos no coincide con el valor esperado.",
      "feature_value_invalid": "Las características de la licencia no coinciden con el valor esperado.",
      "schema_not_match": "Se ha detectado un error de formato del archivo de licencia con respecto a la siguiente información: {field}"
    }
  },
  "status": {
    "title": "Estado de la licencia:",
    "active": "Activa",
    "notActive": "Aún no está activa",
    "warning": "Advertencia",
    "expired": "Caducada"
  },
  "characteristics": {
    "title": "Características",
    "date": {
      "validated": "Fecha de validez:",
      "validatedOn": "Validada el {date}",
      "start": "Fecha de inicio:",
      "end": "Fecha de caducidad:"
    },
    "id": "ID de licencia:"
  },
  "idCard": {
    "title": "Información necesaria para obtener una licencia",
    "description": "Estos identificadores se utilizan para generar una licencia.",
    "export": {
      "title": "Exportar la tarjeta de ID",
      "text": "Exportar la tarjeta de ID"
    },
    "download": "Descargar tarjeta de identificación"
  },
  "overlay": {
    "title": {
      "notFound": "Su organización requiere una licencia",
      "expired": "Su licencia ha caducado"
    },
    "message": {
      "notFound": "Para gestionar su organización, cargue una licencia. El acceso se bloqueará siempre que se haya cargado una licencia válida.",
      "expired": "Para continuar gestionando su organización, renueve su licencia. El acceso se bloquea temporalmente hasta que se resuelva la situación."
    }
  },
  "gauge": {
    "device": {
      "warning": {
        "tooltip": "Ha alcanzado el número de equipos autorizados por su licencia",
        "message": "Umbral alcanzado"
      },
      "error": {
        "tooltip": "No se puede aprovisionar ningún equipo adicional en la plataforma",
        "message": "Límite alcanzado"
      }
    }
  },
  "deviceTypes": {
    "title": "Umbrales del equipo"
  },
  "withoutLimits": "Sin límite",
  "total": "Total",
  "features": {
    "title": "Límites de licencia",
    "interfaces_third_party": "Interfaces",
    "warning": {
      "tooltip": "Ha excedido el límite de su licencia"
    },
    "error": {
      "tooltip": "La creación de nuevos recursos está desactivada"
    }
  },
  "warning": {
    "title": "Se ha alcanzado el límite de licencias.",
    "expirationDateExceeded": "Ha superado la fecha de caducidad de su licencia. Renueve su licencia antes de la interrupción del servicio.",
    "devicesCountExceeded": "Ha superado el número permitido de equipos con su licencia actual. Algunas funcionalidades pueden estar limitadas hasta que se resuelva el problema.",
    "redirect": "Ver panel de licencias"
  }
}
